<!--
// app/components/Shared/icons/LeftArrow.vue
-->
<script setup lang="ts">
type Props = {
  width?: number | string;
  height?: number | string;
};

withDefaults(defineProps<Props>(), {
  height: 14,
  width: 14,
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    class="w-4 h-4"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 10"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M13 5H1m0 0 4 4M1 5l4-4"
    />
  </svg>
</template>

<style scoped></style>
